<ng-container *ngIf="initialized">

    @if (size == 'M') {
        <div (click)="handleClick($event)" class="pointer" *ngIf="registrationDto">
            <inline-template-component
                    [objectType]="'eu.EuRegistration'"
                    [name]="getDisplayName()"
                    [startDate]="registrationDto.startInstant"
                    [showEndTime]="false"
                    [status]="statusLabel"
                    [statusColor]="statusColor"
                    [statusColorBackground]="statusColorBackground"
                    [uiDescription]="registrationDto.phoneNumber"
            >
            </inline-template-component>
        </div>
    }

</ng-container>
